<script>
import {getBaseURL} from "../../url_endpoints";
import {get_UPAYS_auth} from "@/components/hid";

export default {
  name: "CustoKeys",
  data() {
    return {
      apiLink:'',
      keysList:[],
      fromOrigin:0,
    }
  },
  mounted() {
    window.scroll(0,0);
    //this.emitter.emit('heroku', {'eventContent': '1'})
    this.emitter.emit('login_process', {'eventContent': 'ok'})
    this.fromOrigin = this.$route.params.scope
    /* TEST*/
    //this.fromOrigin ='t10'
    this.getBusinessKeys()
    /* reload page - stay in page */
  },
  methods: {
    getBusinessKeys() {
      const baseURL = getBaseURL()
      const auth = get_UPAYS_auth()
      let statusCode = 401
      fetch(baseURL+"/clients/business/"+this.fromOrigin, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      }).
      then(response => {
        switch(response.status){
          case 401: statusCode = 401; break
          case 404: statusCode = 404; break;
          default: statusCode = 500
        }
        return response.json()
      }).then( rsp => {
        if(rsp['auth']) {
          /* check if there are business customers*/
          if(rsp['customers']) {
            //console.log(rsp['customers'])
            this.keysList = rsp['customers']
          }else {
            //console.log('No customers for business')
            this.keysList = []
          }
        }else {
          this.$router.push('/'+statusCode)
        }
      }).catch( err => {
        this.$router.push('/'+statusCode)
        throw new Error('customers codes error - '+err.message)
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<template>
  <body>
  <div style="margin-top: 5vh">
    <h2 v-if="keysList.length === 0">Empty list</h2>
    <div v-else>Payments Keys
      <p>
        <span class="pcard" v-for="(customer,index) in this.keysList" :key="index">
          <span class="pcard_container"><span style="font-weight: bold;font-size: 20px">{{index }}</span> &nbsp;{{customer}}</span>
        </span>
      </p>
    </div>
    <button class="backbtn" @click="goBack">Back</button>
  </div>
  </body>
</template>
<style scoped>
@import "../assets/x_card.css";
a:hover {
  color: #fa755a;
  font-size: 25px;
  cursor: move;
}
.backbtn {
  margin-top: 30px;
  font-size: 30px;
  padding: 10px 10px;
  border-radius: 8px;
  transform:
      perspective(600px)
      rotateX(60deg)
      scale(0.7);
  box-shadow: 0px 20px 100px #555;
  transition:0.5s ease all;

  &:hover {
    transform:
        rotate(0deg)
        scale(1)
        translateY(10px);
  }
}
@media  screen and (max-width: 430px) {
  .pcard_container {
    font-size: 12px;
  }
}

</style>